module.exports = "/_next/static/images/x-line-25ec5d12b8d1f445005e6beb5e9fdcf6.svg";